<template lang="pug">
  .ingredients-v2.row.xs-f-small.max-at-tweak
    .badges-wrap.xs-12
      p.cruelty-text.brand-color-1.xs-f-small.max-at-tweak
        img.cruelty-free-img(:src="crueltyFreeImg.url" :alt="crueltyFreeImg.alt_text")
        span Cruelty Free

    .ingredients-wrap.xs-12
      .ingredient(v-for="item in product.ingredientsFactsheet"  :key="item.title")
        h3.ingredient-title.brand-color-1.xs-f-small.max-at-tweak {{ item.title }}
        p.ingredient-text.text-color-3.xs-f-xsmall.max-at-tweak {{ item.value }}

</template>

<script>
  import { mapState } from "vuex";

  import ResponsiveImage from '@components/ResponsiveImage';

  export default {
    name: "IngredientsV2",

    components: {
      ResponsiveImage,
    },

    computed: {
      ...mapState('global', ['windowData']),
      ...mapState('cms', ['cmsSettings']),
      ...mapState('pdp', ['product']),

      crueltyFreeImg() {
        return this.cmsSettings?.ProductIngredients?.crueltyFreeImage;
      },
    },
  };
</script>

<style scoped lang="stylus">
  .ingredients-v2
    padding 1em 0
    
    .badges-wrap
      .cruelty-text
        position relative
        padding 0.5em 0
        padding-left 3em
        
      .cruelty-free-img
        position absolute
        left 0.1em
        top 0.25em
        width 2em
        height 2em
      
    .ingredients-wrap
      padding 1em 0
      
      .ingredient
        padding-bottom 1.5em
        
        &:last-child
          padding-bottom 0
      
      .ingredient-title
        padding-bottom 0.5em
        
</style>
